import { httpsCallable } from 'firebase/functions'
import { channel } from 'redux-saga'
import { ChannelTakeEffect, SelectEffect, put, select, take, takeEvery } from 'redux-saga/effects'
import { AuthState } from 'redux/modules/auth'
import * as Inquiry from 'redux/modules/inquiry'
import { AppState } from 'redux/store'
import { functions } from 'utils/firebaseApp'

type SendInquiryAction = ReturnType<typeof Inquiry.actions.sendInquiry>

const redirectChannel = channel()

const selectState = <T>(selector: (s: AppState) => T): SelectEffect => {
  return select(selector)
}

const sendInquiry = function* (action: SendInquiryAction) {
  const auth: AuthState = yield selectState((s) => s.auth)
  const user = auth.user
  if (!user) return

  const { title, content } = action.payload

  try {
    yield httpsCallable(functions, 'sendInquiry')({ title, content })
    // 完了アクション
    yield put(Inquiry.actions.sentInquiry(true))
  } catch (e) {
    console.log(e)
    yield put(Inquiry.actions.sentInquiry(false))
  }
}

export default function* dataSaga() {
  yield takeEvery(Inquiry.SEND_INQUIRY, sendInquiry)

  while (true) {
    const action: ChannelTakeEffect<unknown> = yield take(redirectChannel)
    yield put(action)
  }
}
